import { MessageType } from '@app/graphql/types'
import { useCustomerForProfileQuery } from '@app/queries/CustomerforProfile/CustomerForProfile.queries'

export const useClientProfileData = ({ customerId }) => {
  const { data, loading, error } = useCustomerForProfileQuery({
    variables: {
      id: customerId
    },
    fetchPolicy: 'network-only'
  })

  if (loading || error || !data) {
    return {
      loading,
      error,
      data: undefined
    }
  }

  const { customer } = data
  const messages = customer.chat.items

  const lawyerDocs = (messages || [])
    .filter((message) => message.type !== MessageType.Question)
    .reduce((acc, message) => {
      return [...acc, ...(message.documents || [])]
    }, [])

  const customerDocs = (messages || [])
    .filter((message) => message.type === MessageType.Question)
    .reduce((acc, message) => {
      return [...acc, ...(message.documents || [])]
    }, [])

  const customerInfo = {
    id: customer.id,
    profilePictureUrl: customer.profilePictureUrl || undefined,
    firstName: customer.firstName || undefined,
    lastName: customer.lastName || undefined,
    productName:
      customer.membership?.product.name || customer.purchases.last?.product?.name || undefined,
    gender: customer.gender || undefined,
    phone: customer.phone || undefined,
    email: customer.email,
    membershipNumber: customer.membership?.membershipNumber || undefined,
    dateOfBirth: customer.dateOfBirth ? new Date(customer.dateOfBirth) : undefined,
    note: customer.note?.note || undefined
  }

  return {
    loading,
    error,
    data: {
      customerInfo,
      customerDocs,
      lawyerDocs
    }
  }
}
